import { render, staticRenderFns } from "./NoticesAdd.vue?vue&type=template&id=b9db8e6a&scoped=true&"
import script from "./NoticesAdd.vue?vue&type=script&lang=js&"
export * from "./NoticesAdd.vue?vue&type=script&lang=js&"
import style0 from "./NoticesAdd.vue?vue&type=style&index=0&id=b9db8e6a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9db8e6a",
  null
  
)

export default component.exports